
export const DEFAULT_PAGE_SIZE_OPTIONS: Array<String> = ['20', '50', '100'];
export const DEFAULT_DOWNLOAD_NEWS_SOURCE = 100;
export const DESENSITIZE_FIELDS = ['name','phone'];
// ['病例征集', '病患拜访', '营销', '幻灯片制作及审核', '引流服务', '定向推广', '学术', '患者疗效评价', '受试者访视', '资讯生态推广', '视频生态推广']
export const DOCTOR_SUPPORT_TASK_TYPE = ['case', 'visit_patient_custom', 'marketing_custom', 'consult_slide_custom', 'drainage_custom', 'directional_extension_custom', 'academic', 'patient_efficacy_evaluation', 'subject_visit', 'pop_public_ip', 'pop_public_vp']
export const DOCTOR_SUPPORT_PLAN_TYPE = ['academic', 'marketing', 'clinical_research']